import styled from 'styled-components';

export const CaseTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 20px;
  min-width: 400px;
`;
